const productIds = Object.freeze({
  UOL_HOST_ID: 10,
});

const postbackPatterns = Object.freeze({
  PLACEHOLDER_PATTERN: /\{([\w-]+)\}/g,
  PAIR_PATTERN: /&?([\w-]+)=\{([\w-]+)\}/g,
  PRE_DEF_PATTERN: /codAffiliated|codTransaction|value|quantity|codPromotion|desLabel|affTest|affDate|clickUid|eventStatus|productName|affRedir/i,
});

export {
  productIds,
  postbackPatterns,
};
